import React from 'react';
import validator from 'validator';
import { formatText } from 'core/i18n';
import { COUNTRY_DOCUMENT_TYPE_DNI } from 'constants/multiLanguage';
import { InputText } from 'components/inputText/inputText';
import { getLastNameValidationRegExp } from 'commonsUtilities/validations';
import { mustShowSecondLastNameFields } from 'utilities/logicByCountry';

export const SecondLastName = ({ userProfile, userProfileForm, formActions, validateGroups, onFocus }) => {
    const isDocumentTypeDNI = userProfile.documentType === COUNTRY_DOCUMENT_TYPE_DNI;

    const isSecondLastNameRequired = isDocumentTypeDNI ? value => value.length : false;

    const isValidSecondLastNameForCountry = (value, country) =>
        validator.matches(value, getLastNameValidationRegExp[country]);

    const isValidSecondLastNameLength = value => value.length <= 26 && value.length >= 2;

    const isValidSecondLastName = value =>
        isValidSecondLastNameForCountry(value, __ORIGIN_COUNTRY__) && isValidSecondLastNameLength(value);

    const handlePlaceholder = isDocumentTypeDNI
        ? formatText('field-placeholderSecondLastName')
        : formatText('field-placeholderOptionalSecondLastName');

    const handleValidations = {
        required: isSecondLastNameRequired,
        valid: isValidSecondLastName,
    };

    const handleMessagesError = {
        required: formatText('validation-fieldRequired'),
        valid: formatText('validation-syntaxError'),
    };

    if (mustShowSecondLastNameFields()) {
        return (
            <div className="row form__input md-form-group">
                <div className="col-lg-12">
                    <label htmlFor="secondLastName">{formatText('field-secondLastName')}</label>
                </div>
                <div className="col-sm-6">
                    <InputText
                        profileModel="userProfile.secondLastName"
                        placeholder={handlePlaceholder}
                        type="text"
                        inputMode="text"
                        name="secondLastName"
                        autoCompleteFieldCustom={'family-name'}
                        defaultValue={userProfile.secondLastName}
                        isNotValidated={() => validateGroups?.('secondLastName', false)}
                        isValidated={() => validateGroups?.('secondLastName', true)}
                        validations={handleValidations}
                        messagesError={handleMessagesError}
                        errorClass="form__field_error name-errors"
                        userProfileForm={userProfileForm}
                        userProfile={userProfile}
                        formActions={formActions}
                        onFocus={onFocus}
                    />
                </div>
            </div>
        );
    }

    return null;
};
